<template>
    <div class="cart-controls">
        <div class="add">
            <drop-down :value="amount"
                       :options="amountOptions"
                       @input="updateAmount($event)"
                       unit="Stück"
                       class="add__amount add__element"></drop-down>
            <div class="add__button add__element" @click="cartButtonClickHandler" id="mytw_add_to_cart">
                <div class="add__button__text">In den Warenkorb</div>
                <div class="add__button__sum">
                    <span>{{ singlePriceFormatted }} / Stk.</span>
                </div>
            </div>
        </div>

        <p class="cart-controls__notice">
            Mindestabnahme: {{ minQuantity }} Stück, ({{minQuantity / groupOf}} Packungen à {{groupOf}} Artikel)<br>
            Gesamtpreis: {{ sumPriceFormatted }}
        </p>
    </div>
</template>

<script>
    import {mapActions, mapMutations, mapState} from "vuex"
    import DropDownField                        from "./ui/DropDownField"

    export default {
        name:       "CartControls",
        components: {
            'drop-down': DropDownField
        },
        props:      ['pc'],
        data:       function () {
            return {
                minQuantity: 1,
                maxQuantity: 250,
                groupOf:     4,
                singlePrice: 0,
            }
        },
        mounted:    function () {
            this.loadProduct()
                .then(product => {
                    this.singlePrice    = parseFloat(product.regular_price)
                    let minQuantityAttr = product.meta_data.filter(meta => meta.key === 'minimum_allowed_quantity' && !isNaN(parseInt(meta.value)))
                    let maxQuantityAttr = product.meta_data.filter(meta => meta.key === 'maximum_allowed_quantity' && !isNaN(parseInt(meta.value)))
                    let groupOfQuantity = product.meta_data.filter(meta => meta.key === 'group_of_quantity' && !isNaN(parseInt(meta.value)))

                    if (minQuantityAttr.length > 0) {
                        this.minQuantity = parseInt(minQuantityAttr[0].value)
                        this.updateAmount(this.minQuantity);
                    }

                    if (maxQuantityAttr.length > 0) {
                        this.maxQuantity = parseInt(maxQuantityAttr[0].value)
                    }

                    if (groupOfQuantity.length > 0) {
                        this.groupOf = parseInt(groupOfQuantity[0].value)
                    }
                })

            this.$expiviReady.then(expivi => {
                expivi._events.onChange.subscribe((e) => {
                    if (e.name === 'frame') {
                        expivi.getPrice().then(price => {
                            this.singlePrice = price
                        })
                    }
                })
            })
        },
        computed:   {
            ...mapState(['amount']),

            /**
             * Calculates the summed up price with the amount of the item
             */
            sumPrice: function () {
                return this.singlePrice * this.amount;
            },

            /**
             * Outputs the actual summed price of the product
             */
            sumPriceFormatted: function () {
                return Intl.NumberFormat('de-DE', {
                    style:           'currency',
                    currency:        'EUR',
                    currencyDisplay: 'symbol'
                }).format(this.sumPrice)
            },

            singlePriceFormatted: function () {
                return Intl.NumberFormat('de-DE', {
                    style:           'currency',
                    currency:        'EUR',
                    currencyDisplay: 'symbol'
                }).format(this.singlePrice)
            },

            amountOptions: function () {
                let options = [];

                if (this.minAttr === 0 || this.maxAttr === 0 || this.stepAttr) {
                    for (let i = this.minAttr; i <= 250; i = i + this.stepAttr) {
                        options.push(i)
                    }
                }

                return options;
            },

            minAttr: function () {
                return !isNaN(this.minQuantity) ? this.minQuantity : 1
            },

            maxAttr: function () {
                return !isNaN(this.maxQuantity) ? this.maxQuantity : 250
            },

            stepAttr: function () {
                return !isNaN(this.groupOf) ? this.groupOf : 1
            },
        },
        methods:    {
            ...mapActions(['loadProduct']),
            ...mapMutations(['updateAmount']),

            /**
             *
             */
            cartButtonClickHandler: function () {
                this.addDataLayer({
                    'event': 'mytw_add_to_cart_general'
                })

                this.$emit('clicked:cart')
            }
        }
    }
</script>

<style scoped>

</style>
